import { useAuthenticator } from '@aws-amplify/ui-react';
import { forwardRef, useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import { queryKeys } from '@/constants/query-key';
import { ApiNamePaths } from '@/constants/rest-api-name-path';
import { useGenericQuery } from '@/modules/hooks/use-query';
import { settingState } from '@/state/settingState';
import type { CodeMasterApiResponse } from '@/types/code-master';

const Header = forwardRef<HTMLDivElement>(() => {
  const [, setSetting] = useRecoilState(settingState);
  const [fetchEnable, setFetchEnable] = useState<boolean>(false);
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);

  const { data, refetch } = useGenericQuery<CodeMasterApiResponse>(
    queryKeys.codeMasters,
    ApiNamePaths.codeMasterApi.apiName,
    ApiNamePaths.codeMasterApi.apiPath,
    { enabled: fetchEnable },
  );

  useEffect(() => {
    if (['authenticated'].includes(authStatus)) {
      setFetchEnable(true);
    } else {
      setFetchEnable(false);
    }
  }, [authStatus]);

  useEffect(() => {
    if (['authenticated'].includes(authStatus)) {
      void refetch();
    }
    if (data?.data && ['authenticated'].includes(authStatus)) {
      setSetting((state) => ({ ...(state || {}), codeMasters: data.data }));
    }
  }, [data, setSetting, refetch, authStatus]);

  return null;
});

export default Header;
